import { motion } from 'framer-motion';

// A thin gold line that "draws" itself in as the visitor scrolls to a new
// section — a minimal, elegant chapter break.
export const SectionDivider = ({ className = '' }) => {
  return (
    <div className={`flex items-center justify-center bg-[#0A0A0A] py-10 ${className}`} data-testid="section-divider">
      <motion.div
        className="h-[1px] bg-[hsl(var(--lxra-gold))]"
        initial={{ width: 0, opacity: 0 }}
        whileInView={{ width: 96, opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      />
    </div>
  );
};
